'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeEntity = exports.entity = exports.payload = undefined;

var _curry = require('lodash/fp/curry');

var _curry2 = _interopRequireDefault(_curry);

var _compose = require('lodash/fp/compose');

var _compose2 = _interopRequireDefault(_compose);

var _prop = require('lodash/fp/prop');

var _prop2 = _interopRequireDefault(_prop);

var _immutable = require('immutable');

var _Maybe = require('../fp/Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

var _mapProp = require('../fp/mapProp');

var _mapProp2 = _interopRequireDefault(_mapProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get payload from action.
 * payload :: Just a -> Just b
 * @param {Action} action
 * @returns {Just}
  * * */
var payload = exports.payload = (0, _compose2.default)((0, _mapProp2.default)('payload'), _Maybe2.default.of);

/**
 * Get specified entity from normalized action.
 * entity :: string -> Action -> Just a
 * @param {String} entityName
 * @param {Action} action
 * @returns {Just}
  * */
var entity = exports.entity = (0, _curry2.default)(function (entityName, action) {
  return payload(action).map((0, _prop2.default)('entities')).map((0, _prop2.default)(entityName));
});

/**
 * Merge the specified entity on the action to the state
 * @param {Map} state
 * @param {Action} action
 * @param {String} entityName
 * @returns {Map}
  * */
var mergeEntity = exports.mergeEntity = (0, _curry2.default)(function (state, action, entityName) {
  var s = state || new _immutable.Map();
  return (0, _Maybe.maybe)(s, function (e) {
    return s.mergeDeep((0, _immutable.fromJS)(e));
  }, entity(entityName, action));
});